import { generatePath } from 'react-router-dom';

import { createRouteConfig } from 'modules/common/utils/createRouteConfig';

const ROOT_PATH = '/';
const DEFI_PATH = `${ROOT_PATH}/defi`;

export const defiRoutesConfig = createRouteConfig(
  {
    defi: {
      path: DEFI_PATH,
      generatePath: () => generatePath(DEFI_PATH),
    },
  },
  ROOT_PATH,
);
